import { useCallback } from "react";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";
import { createRoot } from "react-dom/client";
import * as ReactHookForm from "react-hook-form";
import * as ReactRouter from "react-router";
import { BrowserRouter } from "react-router";

import * as FaroReact from "@grafana/faro-react";
import * as ReactQuery from "@tanstack/react-query";
import * as CapitalRxComponents2 from "capitalrx-components-2.0";
import * as Color from "capitalrx-components-2.0/lib/general/Color";
import * as CapitalRxHotkeys from "capitalrx-hotkeys";
import { LibraryRegistrationFn, Shell, ShellSwitch } from "capitalrx-shell";
import * as CapitalRxUtilities from "capitalrx-utilities";
import "core-js";

import "./faro";

import "./styles.global.scss";

const queryClient = new ReactQuery.QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * The application index.
 */
const Index = (): JSX.Element => {
  const initializeSharedLibrariesHandler = useCallback((register: LibraryRegistrationFn) => {
    const PatchedReactRouter = {
      ...ReactRouter,
      Switch: ShellSwitch,
    };

    register("@grafana/faro-react", FaroReact);
    register("react", React);
    register("react-dom", ReactDOM);
    register("react-dom/client", ReactDOMClient);
    register("react-router", PatchedReactRouter);
    register("@tanstack/react-query", ReactQuery);
    register("capitalrx-components-2.0", CapitalRxComponents2);
    register("capitalrx-components-2.0/lib/typography", CapitalRxComponents2.Typography);
    register("capitalrx-components-2.0/lib/general", CapitalRxComponents2.General);
    register("capitalrx-components-2.0/lib/layout", CapitalRxComponents2.Layout);
    register("capitalrx-components-2.0/lib/forms", CapitalRxComponents2.Forms);
    register("capitalrx-components-2.0/lib/general/Color", Color);
    register("capitalrx-hotkeys", CapitalRxHotkeys);
    register("capitalrx-utilities", CapitalRxUtilities);
    register("react-hook-form", ReactHookForm);
  }, []);

  return (
    <BrowserRouter>
      <ReactQuery.QueryClientProvider client={queryClient}>
        <Shell onInitializeSharedLibraries={initializeSharedLibrariesHandler} />
      </ReactQuery.QueryClientProvider>
    </BrowserRouter>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Index />);
